import TablaPaginada from "components/comun/TablaPaginada";
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";

const ListHorarios = (props) => {
    const cabecera = ( <>
      
    <th scope="col">Horario</th>
    <th scope="col">Action</th></>);

const datos = (<>{
    props.horarios.map((horario) => (
          <tr key={horario.id} >
            <td>
               {horario.titulo}
            </td>
            
            <td>
            <UncontrolledDropdown >
              <DropdownToggle
                className="btn-icon-only"
                href=""
                role="button"
                size="sm"
                color=""
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" >
             
                <Link to={`/admin/horarios/horario/${horario.id}`}>
                  <DropdownItem
                  >
                    Editar
                  </DropdownItem>
                </Link>
               
               
              </DropdownMenu>
            </UncontrolledDropdown>
            </td>
          </tr>
        ))}
        </>
);
  return (
    <>
          <Card className="shadow">
        <CardHeader className="border-0">
          <Row>
            <Col>
              <h3 className="mb-0">Horarios: </h3>
            </Col>
            <Col className="text-right">
              {" "}
              <Link className="btn btn-primary" to="add">
                Añadir
              </Link>
            </Col>
        
          </Row>
        </CardHeader>
        <TablaPaginada cabecera={cabecera}  datos={datos} currentPage={props.currentPage} totalPage={props.totalPage} setCurrentPage={props.setCurrentPage}></TablaPaginada>
      </Card>
        
    </>
  );
};

export default ListHorarios;

